import React from 'react';

import BadgeCDS from 'app/shared/componentsRestyled/coreDesignSystem/BadgeCDS';

import { EM_DASH } from 'constants/ui';

import InitiatedByCell from '../InitiatedByCell';
import { formatRequestDate } from '../VendorRequestDetailDrawer/VendorRequestDetailDrawer.utils';
import { getGroupInitiatedByUserId, getGroupLatestActivity } from '../vendorRequests.groups';
import VendorRequestStatusLabel from '../VendorRequestStatusLabel';

import {
  DATE_COLUMN_WIDTH,
  NARROW_COLUMN_WIDTH,
  VendorRequestsColumnId,
} from './VendorRequestsTable.constants';

export const vendorRequestsTableConfig = {
  [VendorRequestsColumnId.REQUEST_TYPE]: {
    label: 'Request Type',
    content: ({ requestType }) => requestType || EM_DASH,
  },
  [VendorRequestsColumnId.VENDOR_NAME]: {
    label: 'Vendor',
    content: ({ vendorName }) => vendorName || EM_DASH,
  },
  [VendorRequestsColumnId.STATUS]: {
    label: 'Status',
    width: NARROW_COLUMN_WIDTH,
    content: ({ status }) => <VendorRequestStatusLabel status={status} />,
  },
  [VendorRequestsColumnId.ITEM_COUNT]: {
    label: 'Items',
    width: NARROW_COLUMN_WIDTH,
    content: ({ itemCount }) => <BadgeCDS value={itemCount ?? 0} />,
  },
  [VendorRequestsColumnId.LATEST_ACTIVITY]: {
    label: 'Latest Activity',
    width: DATE_COLUMN_WIDTH,
    content: group => formatRequestDate(getGroupLatestActivity(group)) || EM_DASH,
  },
  [VendorRequestsColumnId.CREATED_AT]: {
    label: 'Created',
    width: DATE_COLUMN_WIDTH,
    content: ({ createdAt }) => formatRequestDate(createdAt) || EM_DASH,
  },
  [VendorRequestsColumnId.INITIATED_BY]: {
    label: 'Initiated By',
    content: group => <InitiatedByCell userId={getGroupInitiatedByUserId(group)} />,
  },
};
